import React from 'react';
import './EmptyState.css';

/**
 * EmptyState — Displayed when no data is available
 * 
 * @param {string} title - Main message
 * @param {string} description - Additional details
 * @param {React.ReactNode} icon - Optional large icon
 * @param {React.ReactNode} action - Optional action button
 */
const EmptyState = ({
  title = "No data found",
  description,
  icon,
  action,
  className = '',
}) => {
  return (
    <div className={`ck-empty-state ${className}`}>
      {icon && <div className="ck-empty-state-icon">{icon}</div>}
      <h4 className="ck-empty-state-title">{title}</h4>
      {description && <p className="ck-empty-state-desc">{description}</p>}
      {action && <div className="ck-empty-state-action">{action}</div>}
    </div>
  );
};

export default EmptyState;
